const { P } = require("handlebars/dist/handlebars.js");

window.handle = require("handlebars/dist/handlebars.js");

handle.registerHelper('stripHtml', function(label){

    label = handle.escapeExpression(label);
    if(label.indexOf("-->", 3) != -1){

        var comment_position = parseInt(label.indexOf("-->", 3));
        return new handle.SafeString(label.substr(comment_position + 3));

    } else {

        return new handle.SafeString(label)

    }

});

handle.registerHelper('check', function(value, comparator) {
    if(value !== comparator){ return `<li>${value}</li>` ;} // filters out empty list values when description is returned as html not a string 
});

handle.registerHelper('renderArrow', function(index) {
    if(index == 1){ return `<img class="img-responsive full-width" src="img/tcpa_arrow.png">`}; // renders a big arrow that points to the first option
});

handle.registerHelper('recommended', function(index) {
    if(index == 1){ return `<div id="recommended">&#10004; Recommended</div>`} else {return `<div class="number">${index}</div>`}; // renders a big arrow that points to the first option
}); 

let isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}

function get_browser() {
    var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 
    if(/trident/i.test(M[1])){
        tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
        return {name:'IE',version:(tem[1]||'')};
        }   
    if(M[1]==='Chrome'){
        tem=ua.match(/\bOPR|Edge\/(\d+)/)
        if(tem!=null)   {return {name:'Opera', version:tem[1]};}
        }   
    M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
    return {
      name: M[0],
      version: M[1]
    };
 }

var browser=get_browser(); // browser.name = 'Chrome'
                           // browser.version = '40'

let browserFull = `${browser.name} ${browser.version}`;

function iOSversion() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later: <https://bit.ly/TJjs1V>
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    } else {
        return "";
    }
}

let ver = iOSversion();

(function($){
    "use strict";

    let numberOfVehicles; // set these variables to use and set globally
    let currentVehicle;
    let year;
    let make;
    let model;
    let queryString;
    let affid;
    let reqid;
    let ts;
    let isLocal = false;
    let urlParams;
    let mobilePop;
    let numberOfDrivers = 1;
    
    let processingText2 = "Compiling your results";

    $(document).ready(function(){
        
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="session-token"]').attr('content')
            }
        });

        let linkUrl = window.location.href;
        if(window.location.href.indexOf("?") == -1){
            queryString = "";
        } else  {
            queryString = linkUrl.substr(linkUrl.indexOf('?'));
            appendCakeValues(queryString);
        }

        if(window.location.host == "myfastquote.local" || window.location.href.indexOf("preferred.php") !== -1){
            isLocal= true;
        }

        if (Array.isArray(ver)) {
            if(ver[0] <= 15){
                mobilePop = false;
            } else {
                mobilePop = true;
            }
            /*$('body').addClass('iOS-tagged');
        */} else {
            mobilePop = true;
        }
       
        let skipToPop = window.location.href.indexOf("currentInsurer")
        if(skipToPop !== -1){
            urlParams = new URLSearchParams(queryString);
            // skip first question after reloading from popunder
            $(".step1").css({display: "none"});
            if(urlParams.get("currentInsurer") == "1"){
                $(".currentInsurerLength").val("0");
                $(".step3").show();
            } else {
                $(".step2").show();
            }
        }
     
        let months = $(".dateslider").val();
        $(".range-output").html(months + " months")

    })

    $(".totalVehicleCount input").on("click", function(){
        numberOfVehicles = $(this).val();
        currentVehicle = 1;
    })

    $(".year input").on("click", function(){
        year = $(this).val(); // get year value
    })

    $(".show-all-button").click(function(){
        $(".hide").css("display", "flex");
        $(this).css({display: "none"});
    })

    $(document.body).on("click", ".make input", function(){
        make = $(this).val(); // get make value
        $("input[name=make" + currentVehicle + "]").val(make);
        $(".hide").css("display", "none");

        $(".show-all-button").css({display: "flex"})       
        $(".current_make").html(make);
        getModels(year, make); // get models dynamically based on year and make of car
    })


    $(document.body).on("click", ".model input", function(){
        model = $(this).val(); // get make value
        $("input[name=model" + currentVehicle + "]").val(model);

    })

    $(document.body).on("input", "#make", function(){
        make = $(this).val(); // get make value
        $(".hide").css("display", "none");
        $("make" . currentVehicle).val(make);
        $(".show-all-button").css({display: "flex"})       
        $(".current_make").html(make);
        getModels(year, make); // get models dynamically based on year and make of car
    })

    $(document.body).on("input", "#model", function(){
        model = $(this).val(); // get make value
        $("model" . currentVehicle).val(model);
    })

    $("#match").on("click", "form.clicklisting-choice", function(e){
        $(this).fadeOut("slow");
        submitLead($(this), "click-listing");
    })

    $(document.body).on("click",  "div.mav-partner", function(e){
        $(this).fadeOut("slow");
        let provider = $(this).attr("data-carrier");
        submitLead($(this), "click-listing", provider);
    })

    let getModels = (year, make) => {
        // hits database to retrieve vehicel models d ../
        $.ajax({
            type: "GET",
            url: 'assets/ajax/getModel.php',
            data: jQuery.param({year: year, make: make}),
            dataType: "json",
            success: function(resp){
                renderModels(resp, make, currentVehicle);
            }
        })
    }

    let renderModels = (models, make, idx = 1) => {
        let container = $(".models" + idx);

        models.forEach(model => {
            container.append(
                `<div class="col-12 col-sm-5 col-lg-3 model">
                    <input type="radio" class="clickProceed" id="model${idx}-${make} ${model.model_name}" name="model${idx}" value="${model.model_name}">
                    <label for="model${idx}-${make} ${model.model_name}">${model.model_name}</label>
                </div>`
                );
            }) 
    
    }
    
    $(document.body).on("click", ".model input", function(){

        let alert;
        if(window.location.href.indexOf("preferred.php") !== -1){
            alert = "form2-cars";
        } else {
            alert = "alert alert-secondary";
        }
        model = $(this).val(); // get model value
        let index = currentVehicle; 
        let vehicleNumber = index == 1 ? "Primary Vehicle" : "Vehicle " + index;
        let car = `${year} ${make} ${model}`
        $(".status" + index).html(
            `<div class='${alert}'>
                <i class='fas fa-car'></i>
                <strong>${vehicleNumber}:</strong>
                ${car}
            </div>`
        ); // sets div at top to display completed cars
        $("#car" + index).html(car); //sets the html for the garage question
        currentVehicle ++;
    })

    $(document).on("input", "#model", function(e){

        let alert;
        if(window.location.href.indexOf("preferred.php") !== -1){
            alert = "form2-cars";
        } else {
            alert = "alert alert-secondary";
        }

        model = e.target.value; // get model value
        let index = currentVehicle; 
        let vehicleNumber = index == 1 ? "Primary Vehicle" : "Vehicle " + index;
        let car = `${year} ${make} ${model}`
        $(".status" + index).html(
            `<div class='${alert}'>
                <i class='fas fa-car'></i>
                <strong>${vehicleNumber}:</strong>
                ${car}
            </div>`
        ); // sets div at top to display completed cars
        $("#car" + index).html(car); //sets the html for the garage question
        currentVehicle ++;
    })
        
    $(document.body).on("click", '.clickProceed', function(){
        transitionEvents($(this))
    })

    $(document.body).on("input", '#make, #model', function(){
        transitionEvents($(this))
    })

    let transitionEvents = (e) => {
        let skipToPop = window.location.href.indexOf("currentInsurer")
        let slide = e.closest(".steps");
        let idx = slide.attr("id").slice(5);
        reqid = queryString.indexOf("reqid=") !== -1 ? queryString.substring(queryString.lastIndexOf("reqid=") + 6) : "";
        urlParams = new URLSearchParams(queryString);

        let newDriverSlides = ["25", "32", "39"];

        affid = urlParams.get('affid');

        let modelSlides = ["6", "9", "12", "15"]; // get the index of all the final slides for each car - if current vehicle equals total vehicles, skip to school question
        if(idx == 1 && skipToPop == -1 && !isLocal && browserFull !== "Safari 15" && mobilePop){
            // popunder - append value to query string 
            urlParams = new URLSearchParams(queryString);
            ts = urlParams.get('ts')

            let currentInsurer = $("input[name='currentInsurer']:checked").val();
            let appendToQuery = "";
            if(window.location.search){
                appendToQuery = `&currentInsurer=${currentInsurer}`;
            } else {
                appendToQuery = `?currentInsurer=${currentInsurer}`;
            }

            let redirect = "popunder.php?reqid=" + reqid + "&affid=" + affid;

            if(ts !== null){
                redirect += `&ts=${ts}`;
            }
            
            let current_location = window.location.href;
            window.open(current_location + appendToQuery);
            window.location.href = redirect;
            localStorage.setItem('popped', true);
        } else if(idx == 2) {
            $(window).bind('beforeunload', function(){
                return 'Are you sure you want to leave?';
            });

            nextSlide(slide,idx);
        } else if(modelSlides.includes(idx) && currentVehicle > numberOfVehicles){
            nextSlide(slide, "16");
        } else if (idx == "1" && e.val() == "1"){
            $(".currentInsurerLength").val("0");
            nextSlide(slide, 2); 
        } else if(newDriverSlides.includes(idx)){

            if(e.val() == "0"){
                idx = "45";
                nextSlide(slide,idx);
            } else {
                numberOfDrivers ++;
                nextSlide(slide,idx);
            }
        
        } else if(idx == "23"){
            if($("input[name='address']").val() == "") {
                $(".errorMsgAddress").html("Please fill out all fields.")
                return "";
            } else if($("#zip").val() == "" || $("#city").val() == "" || $("#state").val() == "") { 
                $(".errorMsgAddress").html("Please enter valid address.")
                return "";
            } else {
                $(".errorMsgAddress").css({display: "none"});
                nextSlide(slide, idx); 
            }
        } else {
            nextSlide(slide, idx);
        }
    }
    
    let nextSlide = (slide, index) => {
        
        slide.css({display: "none"});
        $(".step" + (parseInt(index) + 1)).show();
        if(index >= 1){
             $(".progress-bracket").css({
                visibility: "visible"
            });
        }

        let newWidth = (Math.round(parseInt(index) * 2.22)).toString() + "%"; // get percentage to use as bar width and display value
        
        $(".progress-val").html(newWidth);

        $("#progress").css({
            width: newWidth 
        }) 
    } 

    // search/match logic

    $("form").on("submit", function(){
        formValidator($(this));
    })

    let formValidator = (ele) => {

        if($('#firstName').val() == ""){return false;}
        if($('#lastName').val() == ""){return false;}
        if($('#email').val() == ""){return false;}
        if($('#phone').val() == ""){return false;}
        if($('#autocompleteAddress').val() == ""){return false;}
        if($('#zip').val() == ""){return false;}
        if($('#city').val() == ""){return false;}
        if($('#state').val() == ""){return false;}
        if($('.invalid').length){return false; }

        $(".status").hide();
        $(".progress-bracket").css({ display: "none" });
        let parentClass = this;
        searchClickListings(parentClass);
        $('button[type=submit], input[type=submit]').prop('disabled',true);
    }

    let processLastSlide = () => {
        $(".step46").hide(300);
        $(".step47").show(400);
        $('#processModal').css({visibility: "visible"}).modal({backdrop: 'static', keyboard: false});
        $('#processModal').modal('show');
        setTimeout("$('#searchInfoText').html('Compiling your results...')",2000);
    }

    let searchExclusives = (parentClass, leadID) => {

        let data = $("#form1").serialize();
        data += "&" + $("#form2").serialize();
        data += `&type=exclusives&id=${leadID}&driverCount=${numberOfDrivers}`;
        $.ajax({
            type: 'post',
            url: 'assets/ajax/search.php',
            data: data,
            dataType: 'json',
            accept: 'json',
            cache: false
        })
        
    }

    let searchClickListings = (parentClass) => {

        $(window).unbind('beforeunload');

        let data = $("#form1").serialize();
        data += "&" + $("#form2").serialize();
        data += `&type=clicklistings&driverCount=${numberOfDrivers}`;

        let array1 = $("#form1").serializeArray();
        let array2 = $("#form2").serializeArray();

        let formArray = [...array1, ...array2];

        $.ajax({
            type: 'post',
            url: 'assets/ajax/search.php',
            data: data,
            dataType: 'json',
            accept: 'json',
            cache: false,
            beforeSend: function(){
                hideModal();
                setTimeout(changeProcessingText, 1000);
            },
            success: function(data){
                if(typeof gtag === "function"){
                    gtag("event", "completion", {
                        Gender: $("input[name='gender']").val(),
                        Married: $("input[name='marital_status']").val() == 2 ? "Married" : "Single",
                        Homeowner: $("input[name='residenceStatus']").val() == 2 ? "Rent" : "Own",
                        Carrier: getInsuranceCarrier($("input[name='currentInsurer']").val()),
                        AffID: $("#affid").val()
                    });
                }
                // fire full form cake pixel $2.50 - $12
                if(data['id']){
                    searchExclusives(parentClass,data['id']);
                }
                processLastSlide();
                setTimeout(function(){displayResults(data, formArray)}, 2000);
                setTimeout(changeProcessingText, 0);
            }
        });
    }

    function getInsuranceCarrier(insurer){
        let val;
        switch(insurer){
            case "1":
                val = "None";
                break;
            case "2": 
                val = "GEICO";
                break;
            case "3": 
                val = "Progressive";
                break;
            case "4": 
                val = "Allstate";
                break;
            case "5": 
                val = "State Farm";
                break;
            case "6":
                val = "Farmers";
                break;
            case "7": 
                val = "USAA";
                break;
            case "8": 
                val = "Liberty Mutual";
                break;
            case "9": 
                val = "Other";
                break;
            case "10":
                val = "Nationwide";
                break;
        }

        return val;
    }

    function hideModal() {
        $("#processModal").removeClass("in");
        $('body').removeClass('modal-open');
        $(".modal-backdrop").remove();
        $("#processModal").css({visibility: "hidden"});
      }

    let displayResults = (matches, formArray) => {
        urlParams = new URLSearchParams(queryString);
        ts = urlParams.get('ts')
        let s1 = urlParams.get('s1');
        let s2 = urlParams.get('s2');
        let utm_source = urlParams.get('utm_source');

        let affid = urlParams.get('affid');
        reqid = queryString.indexOf("reqid=") !== -1 ? queryString.substring(queryString.lastIndexOf("reqid=") + 6) : "";
        let clickMatches = [];

        localStorage.setItem('id', matches.id);
        clickMatches.s1 = s1;
        clickMatches.s2 = s2;
        clickMatches.reqid = reqid;
        clickMatches.affid = affid;
        if(matches.matches && matches.matches.length > 0 ){
           
            let limit = matches.matches.length >= 5 ? 5 : matches.matches.length;
            for(let i = 0; i < limit; i++){
                clickMatches.push({
                    id: matches.id,
                    aggregator: matches.matches[i].aggregator,
                    aggregator_id: matches.matches[i].aggregator_id,
                    reqid: reqid,
                    index: i + 1,
                    logo: matches.matches[i].logo,
                    name: matches.matches[i].name,
                    headline: matches.matches[i].headline,
                    display_url: matches.matches[i].display_url,
                    description: matches.matches[i].description.replace(/<[^>]*>?/gm, "@").split("@"),
                    search_id: matches.matches[i].search_id,
                    click_url: matches.matches[i].click_url,
                    payout: matches.matches[i].price
                })

                if(matches.matches[i].hasOwnProperty('impression_pixel')){
                    clickMatches[i].impression_pixel = matches.matches[i].impression_pixel.replace('{position}', clickMatches[i].index);
                }
            }
            
        }
        
        let viewTemplate;
        let matchView;
        let year; let month; let day; let residenceStatus; let suspended; let sr22;

        const maUtmVals = ['search', 'Search', 'email', 'Email'];

        if(utm_source !== null && maUtmVals.includes(utm_source)){
            viewTemplate = "mediaalpha.html"

            formArray.forEach(item => {
                if(item.name == "year"){
                    year = item.value;
                } else if(item.name == "month") {
                    month = item.value;
                } else if(item.name == "day"){
                    day = item.value;
                } else if(item.name == "residenceStatus"){
                    residenceStatus = item.value;
                } else if(item.name == "suspended") {
                    suspended = item.value;
                } else if(item.name == "sr22"){
                    sr22 = item.value;
                }
            })

            switch(utm_source){
                case "Email":
                case "email":
                    matchView = {
                        "data": {
                            "zip": "auto", 
                            "birthdate": `${year}-${month}-${day}`,
                            "home_ownership": residenceStatus == 2 ? 0 : 1,
                            "sr_22": sr22,
                            "license_status": suspended == 1 ? "Suspended" :"Active"
                        },
                        "placement_id": "G7pbCx6b61fbKjbK9I5NVIrTd7UApQ",
                        "sub_1": affid,
                        "sub_2": s1,
                        "type": "ad_unit",
                        "version": 17,
                        "reqid": reqid,
                        "ma-id": "ma-email-ty",
                    }
                    break;
                case "Search":
                case "search":
                    matchView = {
                        "data": {
                            "zip": "auto", 
                            "birthdate": `${year}-${month}-${day}`,
                            "home_ownership": residenceStatus == 2 ? 0 : 1,
                            "sr_22": sr22,
                            "license_status": suspended == 1 ? "Suspended" :"Active"
                        },
                        "placement_id": "g7NcHfVzYEZnnay_4_5MPY2iUrEtrw",
                        "sub_1": affid,
                        "sub_2": s1,
                        "type": "ad_unit",
                        "version": 17,
                        "reqid": reqid,
                        "ma-id": "ma-search-ty",
                    }
                    break;
                default:
                    matchView = {
                        "data": {
                            "zip": "auto", 
                            "birthdate": `${year}-${month}-${day}`,
                            "home_ownership": residenceStatus == 2 ? 0 : 1,
                            "sr_22": sr22,
                            "license_status": suspended == 1 ? "Suspended" :"Active"
                        },
                        "placement_id": "C8RptMkhUxuJtCJFHnCPSXgGpjixKw",
                        "sub_1": affid,
                        "sub_2": s1,
                        "type": "ad_unit",
                        "version": 17,
                        "reqid": reqid,
                        "ma-id": "ma-search-ty",
                    }
                    break;
                
            }

        } else if(ts !== null){
            viewTemplate = "mediaalpha.html"

            formArray.forEach(item => {
                if(item.name == "year"){
                    year = item.value;
                } else if(item.name == "month") {
                    month = item.value;
                } else if(item.name == "day"){
                    day = item.value;
                } else if(item.name == "residenceStatus"){
                    residenceStatus = item.value;
                } else if(item.name == "suspended") {
                    suspended = item.value;
                } else if(item.name == "sr22"){
                    sr22 = item.value;
                }
            })

            switch(ts) {
                case "646973706C6179": //display
                    matchView = {
                        "data": {
                            "zip": "auto", 
                            "birthdate": `${year}-${month}-${day}`,
                            "home_ownership": residenceStatus == 2 ? 0 : 1,
                            "sr_22": sr22,
                            "license_status": suspended == 1 ? "Suspended" :"Active"
                        },
                        "placement_id": "F2MtAJ3gyidxA8GuMHa49WDuPfrzgg",
                        "sub_1": affid,
                        "sub_2": s1,
                        "type": "ad_unit",
                        "version": 17,
                        "reqid": reqid,
                        "ma-id": "ma-display-ty"
                    }
                    break;
                case "656D61696C": //email
                    matchView = {
                        "data": {
                            "zip": "auto", 
                            "birthdate": `${year}-${month}-${day}`,
                            "home_ownership": residenceStatus == 2 ? 0 : 1,
                            "sr_22": sr22,
                            "license_status": suspended == 1 ? "Suspended" :"Active"
                        },
                        "placement_id": "yw1KMpBFOFvxCXxk54fO8286k2omyQ",
                        "sub_1": affid,
                        "sub_2": s1,
                        "type": "ad_unit",
                        "version": 17,
                        "reqid": reqid,
                        "ma-id": "ma-email-ty"
                    }
                    break;
                case "736561726368": //search
                    matchView = {
                        "data": {
                            "zip": "auto", 
                            "birthdate": `${year}-${month}-${day}`,
                            "home_ownership": residenceStatus == 2 ? 0 : 1,
                            "sr_22": sr22,
                            "license_status": suspended == 1 ? "Suspended" :"Active"
                        },
                        "placement_id": "g7NcHfVzYEZnnay_4_5MPY2iUrEtrw",
                        "sub_1": affid,
                        "sub_2": s1,
                        "type": "ad_unit",
                        "version": 17,
                        "reqid": reqid,
                        "ma-id": "ma-search-ty"
                    }
                    break;
                case "74657374": // media alpha test
                    matchView = {
                        "data": {
                            "zip": "auto"
                        },
                        "placement_id": "FFP4Wiv8T17jmnEyJJoSbZwFcYTCQg",
                        "sub_1": affid,
                        "sub_2": s1,
                        "type": "ad_unit",
                        "version": 17,
                        "reqid": reqid,
                        "ma-id": "ma-search-ty"
                    }
                    break;
                case "736F6369616C": //social
                    matchView = {
                        "data": {
                            "zip": "auto", 
                            "birthdate": `${year}-${month}-${day}`,
                            "home_ownership": residenceStatus == 2 ? 0 : 1,
                            "sr_22": sr22,
                            "license_status": suspended == 1 ? "Suspended" :"Active"
                        },
                        "placement_id": "FFP4Wiv8T17jmnEyJJoSbZwFcYTCQg",
                        "sub_1": affid,
                        "sub_2": s1,
                        "type": "ad_unit",
                        "version": 17,
                        "reqid": reqid,
                        "ma-id": "ma-social-ty"
                    }
                   
        
                    break;
            }

        } else {
            if(isMobile){
                viewTemplate = "mobile-click-listings.html";
            } else {
                viewTemplate = "click-listings.html";
            }  

            matchView = clickMatches;
        } 

        // determine is mobile before calling template

        $.get(viewTemplate, (function(data){
            $("#processModal").modal('hide');
            let template = handle.compile(data);
            $("#match").empty().html(template({clickMatches: matchView})).fadeIn();
            $("#first_name").html($("#firstName").val().trim() + ", ")
            $("#user_city").html(localStorage.getItem('city'));
        }))
    }

    let submitLead = (data,type,provider = null) => {

        let formData;

        if(ts !== null){

            let payout = $("input[name='revenue']").val();
            const id = localStorage.getItem('id')
            if(payout == null || payout == undefined){
                payout = 0;
            }
            formData = `aggregator_id=15&aggregator=MediaAlphaClicks&reqid=${reqid}&provider=${provider}&id=${id}&payout=${payout}`;
        } else {
            let form = data.closest("form");
            formData = form.serialize();
        }

        formData += "&type=" + type;

        $.ajax({
            type: "POST",
            url: "assets/ajax/fireClickListingPixel.php",
            data: formData,
            dataType: "json",
            accept: "json"
        })
    }

    let changeProcessingText = () => {
        $(".ldTemplate-wrapper .processing-text").empty().html(processingText2).fadeIn("slow");
    }

    let lastCall = () => {
        localStorage.setItem('name', $("#firstName").val());
        localStorage.setItem('qs', window.location.href);
        location.assign("search.php");
    }


    let appendCakeValues = (t) => {
        var e = -1 !== t.indexOf("affid=") ? t.substring(t.lastIndexOf("affid=") + 6) : "",
        r = -1 !== e.indexOf("&") ? e.substring(0, e.indexOf("&")) : e;
        $("#affid").val(r);
        var s = -1 !== t.indexOf("s1=") ? t.substring(t.lastIndexOf("s1=") + 3) : "",
            n = -1 !== s.indexOf("&") ? s.substring(0, s.indexOf("&")) : s;
        $("#s1").val(n);
        var i = -1 !== t.indexOf("s2=") ? t.substring(t.lastIndexOf("s2=") + 3) : "",
            a = -1 !== i.indexOf("&") ? i.substring(0, i.indexOf("&")) : i;
        $("#s2").val(a);
        var o = -1 !== t.indexOf("s3=") ? t.substring(t.lastIndexOf("s3=") + 3) : "",
            c = -1 !== o.indexOf("&") ? o.substring(0, o.indexOf("&")) : o;
        $("#s3").val(c);
        var s = -1 !== t.indexOf("currentInsurer=") ? t.substring(t.lastIndexOf("currentInsurer=") + 15) : "",
            n = -1 !== s.indexOf("&") ? s.substring(0, s.indexOf("&")) : s;
        $("#currentInsurerSession").val(n);
    }
    
})(jQuery);